var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmail2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "email2_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h17.396v13.738H0z",
  "data-name": "Rectangle 7713"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19780"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19671"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19671",
  transform: "translate(.126 .067)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "none",
  "data-name": "Ellipse 1392",
  transform: "translate(-.126 -.068)"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19775"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#email2_svg__a)",
  "data-name": "Group 19774",
  transform: "translate(11.3 13.13)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.698 7.647 16.56.664A2.54 2.54 0 0 0 14.843 0H2.553a2.54 2.54 0 0 0-1.72.667Z",
  "data-name": "Path 27434"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.226 9.303a.795.795 0 0 1-1.055 0L.043 2.09A2.6 2.6 0 0 0 0 2.554v8.631a2.553 2.553 0 0 0 2.553 2.553h12.29a2.553 2.553 0 0 0 2.557-2.553V2.554a2.6 2.6 0 0 0-.043-.468Z",
  "data-name": "Path 27435"
})))))));
export { SvgEmail2 as ReactComponent };
export default __webpack_public_path__ + "static/media/email2.941721374e835daebf9ba6ebf24fd8f1.svg";